import { ACCOUNT_NAV_ITEMS, TEAM_SETTINGS_SIDEBAR_NAV_ITEMS } from '../helpers/settings-list';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { SettingsOption } from '../types';
import { isDefined } from '../helpers/utils';
import organizationInfo from '../helpers/state/organization-info';

@customElement('settings-sidebar')
export class BackpackSidebar extends LitElement {
    amplitude_callsite: string = 'Settings Sidebar';

    @property()
    type: string = 'Account';

    @property({ type: Array })
    options: SettingsOption[] = ACCOUNT_NAV_ITEMS;

    @state()
    settingSection?: string | undefined;

    private onSelectNavItem(settingSectionInfo: any) {
        this.dispatchEvent(new CustomEvent('on-select-filter-type', {
            detail: {
                settingSectionInfo,
            }
        }));
    }

    async firstUpdated() {
        this.startup();
    }


    startup() {
        // if type is "Team" get the TEAM_SETTINGS_SIDEBAR_NAV_ITEMS
        if (this.type === 'Team') {
            this.settingSection = TEAM_SETTINGS_SIDEBAR_NAV_ITEMS[0].settingSection;
            this.options = TEAM_SETTINGS_SIDEBAR_NAV_ITEMS;
            if (organizationInfo.organization?.is_administrator === true) {
                this.options = TEAM_SETTINGS_SIDEBAR_NAV_ITEMS;
            } else if (organizationInfo.organization?.is_collaborator === true) {
                this.options = TEAM_SETTINGS_SIDEBAR_NAV_ITEMS.filter((item) => item.label === 'Teammates');
                this.settingSection = 'Teammates';
            } else if (organizationInfo.organization?.is_writer === true) {
                this.options = TEAM_SETTINGS_SIDEBAR_NAV_ITEMS.filter((item) => item.label !== 'Subscription, Billing, & Invoices');
            } else {
                this.options = [];
            }
        } else {
            this.settingSection = ACCOUNT_NAV_ITEMS[0].settingSection;
            if (isDefined(organizationInfo.organization)) {
                this.options = ACCOUNT_NAV_ITEMS.filter((item) => item.label !== 'Subscription, Billing, & Invoices');
            } else {
                this.options = ACCOUNT_NAV_ITEMS;
            }
        }
    }

    render() {
        return html`
            <div class="settings-sidebar__team-settings-links">
                ${this.options.map(
                    (item) =>
                        html`
                            <div @click=${() => this.onSelectNavItem(item)} class="settings-sidebar__team-settings-page-link ${this.settingSection === item.settingSection ? 'selected' : ''}">
                                <div class="settings-sidebar__team-settings-page-name">
                                    <img class="settings-sidebar__img" src=${item.img} />
                                    <span>${item.label}</span>
                                </div>
                            </div>
                        `
                )}
            </div>
        `;
    }

    static get styles() {
        return css`
            .settings-sidebar__team-settings-links {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: center;
                gap: 0.5rem;
            }

            .settings-sidebar__team-settings-page-name {
                display: flex;
                align-items: center;
                flex: 1 1 0%;
            }

            .settings-sidebar__team-settings-page-link {
                color: var(--main-primary-color);
                text-decoration: none;
                cursor: pointer;
                padding: 0.25rem 0.75rem;
                display: flex;
                flex-direction: row;
                align-content: space-between;
                align-items: center;
                gap: 0.5rem;
                box-sizing: border-box;
            }

            .settings-sidebar__team-settings-page-link.selected {
                font-weight: 500;
                border-bottom: 2px solid var(--main-primary-color);
                background-color: var(--main-primary-color-10);
            }

            .settings-sidebar__img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }

            @media (min-width: 551px) {
                .desktopOnly {
                    display: block;
                }


                .mobileOnly {
                    display: none;
                }
            }

            @media (max-width: 550px) {
                .desktopOnly {
                    display: none;
                }

                .mobileOnly {
                    display: block;
                }
            }
        `;
    }
}
